<script>
import httpService from '@/core/api/request'
export default {
  data: function () {
    return {
      types: null
    }
  },
  methods: {
    getTypes: function () {
      let httpRequest = {
        params: '',
        module: 'attribute_types'
      }
      this.get(httpRequest)
        .then(
          types => {
            this.types = types.data
          }
        ).catch(
          () => {
            this.types = null
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/attributes/mixins.vue